import { useContext } from 'react'
import { HeaderContext, HeaderContextValues } from './context'

export const useHeaderConfig = (): HeaderContextValues => {
  return useContext(HeaderContext)
}
